<script lang="ts" setup>
const { getIndustryAttributes, getMetaAttributes } = useApiAttributes()
const { t } = useI18n()
const api = useApi()

const endpoints: ApiEndpoint[] = [
  {
    method: 'GET',
    path: '/industries',
  },
]

const queryAttributes: ApiAttribute[] = [
  {
    description: t('attributes.page'),
    example: '/industries?page=1',
    name: 'page',
    optional: true,
    type: 'number',
  },
  {
    description: t('attributes.search'),
    example: '/industries?search=saas',
    name: 'search',
    optional: true,
    type: 'string',
  },
  {
    description: t('attributes.size'),
    example: '/industries?size=10',
    name: 'size',
    optional: true,
    type: 'number',
  },
]

const responseAttributes: ApiAttribute[] = [
  {
    attributes: getIndustryAttributes(),
    description: t('response.industries'),
    name: 'industries',
    type: 'array',
  },
  getMetaAttributes(),
]

async function onVisibilityChange(visibility: boolean) {
  if (visibility && !response.value) {
    await execute()
  }
}

const { data: response, execute, status } = useAsyncData(
  'doc:industries-search',
  () => api.industries.fetch(),
  { immediate: false },
)
</script>

<template>
  <ApiDoc
    :endpoints="endpoints"
    :loading="status === 'pending'"
    :query-attributes="queryAttributes"
    :response="response?.data"
    :response-attributes="responseAttributes"
    @visibility-change="onVisibilityChange"
  />
</template>

<i18n lang="json">
{
  "en": {
    "attributes": {
      "page": "The page to fetch (default to 1).",
      "search": "An additional search query applied to the industry name.",
      "size": "The number of industries to be returned (between 1 and 100). Default to 25."
    },
    "response": {
      "industries": "The industries that match your conditions."
    }
  },
  "es": {
    "attributes": {
      "page": "La página a recuperar (por defecto 1).",
      "search": "Una consulta de búsqueda adicional aplicada al nombre de la industria.",
      "size": "El número de industrias a devolver (entre 1 y 100). Por defecto 25."
    },
    "response": {
      "industries": "Las industrias que coinciden con tus criterios."
    }
  },
  "fr": {
    "attributes": {
      "page": "La page à récupérer (par défaut 1).",
      "search": "Une requête de recherche supplémentaire appliquée au nom de l'industrie.",
      "size": "Le nombre d'industries à renvoyer (entre 1 et 100). Par défaut 25."
    },
    "response": {
      "industries": "Les industries qui correspondent à vos critères."
    }
  }
}
</i18n>
